<template>
	<div class="video_news">
		<p>
			<i class="el-icon-s-home"></i>
			<span @click="$router.replace('/')">网站首页</span>/ 新闻动态/ 视频新闻
		</p>
		<ul>
			<li v-for="(item, index) in list" :key="index">
				<img width="100%" :src="item.imgurl" alt="">
			</li>
		</ul>
		<el-pagination @current-change='currentPageNum' :background="true" layout="total, prev, pager, next" :total="total"></el-pagination>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				total: 0,
			};
		},
		mounted() {
			this.getData(1)
		},
		methods: {
			// 当前页
			currentPageNum(val) {
				this.getData(val)
			},
			getData(pageNum) {
				this.$axios({
					url: 'http://wine.gzcc315.com/getCpImg',
					method: 'post',
					data: this.$qs.stringify({
						pageNum: pageNum,
						type: 2
					}) 
				}).then(res => {
					this.list = res.data.data.list;
					this.total = res.data.data.total;
				})
			},
		},
	};
</script>
<style scoped>

	.video_news > p {
		width: 100%;
		border-bottom: 1px solid #ddd;
		padding-bottom: 10px;
		color: gray;
	}

	.video_news > p i {
		margin-right: 10px;
	}

	.video_news > p span:hover {
		color: #016fb8;
		cursor: pointer;
	}

	.video_news ul {
		width: 100%;
		padding: 20px 30px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		box-sizing: border-box;
	}
	.video_news ul li {
		width: 48%;
		margin-bottom: 20px;
	}
</style>
